// extracted by mini-css-extract-plugin
export default {"uploadDocumentSection":"UploadForm_uploadDocumentSection__shPD4","uploadText":"UploadForm_uploadText__Fm16w"};